import { Box, Typography, TextField, MenuItem } from '@mui/material';

// Subcomponent for dropdown questions
const DropdownQuestion = ({ question, questionNumber, answerOptions, onAnswerChange, answer }) => (
  <Box sx={{ mb: 6 }}>
    <Typography variant="body1" sx={{ mb: 4 }}>
      {questionNumber}. {question.text}
    </Typography>
    {(question.items || [null]).map((item, itemIndex) => (
      <Box key={item?.id || 0} sx={{ mb: question.items ? 3 : 0 }}>
        <TextField
          label={item ? item.label : ''}
          select
          fullWidth
          value={question.items ? answer?.[itemIndex] ?? '' : answer ?? ''}
          onChange={e => onAnswerChange(e.target.value, question.items ? itemIndex : undefined)}
          variant="outlined"
        >
          {answerOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    ))}
  </Box>
);

export default DropdownQuestion;